import { Component, Injector, Input, OnInit, SimpleChanges } from '@angular/core';
import { AppComponentBase } from 'src/app/shared/app-component-base';

@Component({
  selector: 'app-simple-pie-chart',
  templateUrl: './simple-pie-chart.component.html',
  styleUrls: ['./simple-pie-chart.component.scss']
})
export class SimplePieChartComponent extends AppComponentBase implements OnInit {
  chartOptions: any
  @Input() series!: number[];
  @Input() labels!: string[];
  @Input() isLoaded: boolean = false;


  constructor(injector: Injector) {
    super(injector);
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (this.isLoaded) {
      this.chartOptions.series = this.series;
      this.chartOptions.labels = this.labels;
    }

  }

  ngOnInit(): void {

    this.chartOptions = {
      series: this.series,
      chart: {
        height: 350,
        type: 'radialBar',
      },
      plotOptions: {
        radialBar: {
          dataLabels: {
            name: {
              fontSize: '22px',
            },
            value: {
              fontSize: '16px',
            },
            total: {
              show: true,
              label: 'Total',
              formatter: function () {
                // By default this function returns the average of all series. The below is just an example to show the use of custom formatter function
                return 249
              }
            }
          }
        }
      },
      labels: this.labels,
    };
  }


}
